import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const SmartphoneIcon = createIcon({
  displayName: 'SmartphoneIcon',
  path: <path fillRule="evenodd" clipRule="evenodd" d="M5 23V1H19V23H5ZM7 19H17V5H7V19Z" fill="currentColor" />,
  viewBox: '0 0 24 24',
})
